import React, { createContext, useState, useContext, useEffect } from 'react';
import Cookies from 'js-cookie';

const AuthContext = createContext({});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const token = Cookies.get('auth_token');
    if (token) {
      try {
        // Decode JWT to get user info
        const payload = JSON.parse(atob(token.split('.')[1]));
        setUser({ 
          username: payload.username, 
          id: payload.userId,
          passwordId: payload.passwordId,
          expiryDate: payload.expiryDate
        });
        setIsAdmin(payload.isAdmin || false);
      } catch (error) {
        console.error('Invalid token:', error);
        Cookies.remove('auth_token');
      }
    }
    setLoading(false);
  }, []);

  const login = async (password) => {
    try {
      const response = await fetch('/.netlify/functions/auth-login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Login fehlgeschlagen');
      }

      Cookies.set('auth_token', data.token, { expires: 7 });
      setUser({ 
        username: data.username, 
        id: data.userId,
        passwordId: data.passwordId,
        expiryDate: data.expiryDate
      });
      setIsAdmin(data.isAdmin || false);
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  const logout = () => {
    Cookies.remove('auth_token');
    setUser(null);
    setIsAdmin(false);
  };

  const value = {
    user,
    isAdmin,
    login,
    logout,
    loading,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
